<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          routeBack="VideoIndex"
          :title="getValue('title')"/>
        <show-actions
          :deleteItem="allowDelete&&video&&video.nbSheetLinked===0"
          :editItem="allowEdit"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Video.title') }}</div>
                  <div> {{ getValue('title') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Video.url') }}</div>
                  <a :href="video.urlLink" target="_blank"> {{ getValue('urlLink') }}</a>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="video"
      controllerName="resource"
      itemSingularName="video"
      itemSingularNameUpp="Video"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'VideoShow',

  components: {
    BackArrow,
    DateField,
    ShowActions,
    ItemDeleteModal
  },

  computed: {
    getValue () {
      return (path) => {
        const properties = path.split('.')
        let value = properties.reduce((prev, curr) => {
          return prev && prev[curr] ? prev[curr] : null
        }, this.video)
        return value !== null ? value : 'N/A'
      }
    }
  },

  data () {
    let isAuthorized = this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
    return {
      videoId: this.$route.params.videoId,
      video: {},
      allowDelete: isAuthorized,
      allowEdit: isAuthorized
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    getFileUrl (path) {
      return process.env.SERVER_URL + path
    },

    async fetchData () {
      if (this.videoId) {
        await this.fetchVideo()
      }
    },

    async fetchVideo () {
      api
        .get('/resource/' + this.videoId)
        .then(response => {
          this.video = response.data
        })
    },

    clickOnDownloadBtn (fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus()
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'VideoEdit',
        params: {
          videoId: this.video.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.$router.push({
        name: 'VideoIndex'
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/videoRobustagno/VideoShow.vue